import React, { useCallback, useEffect, useState } from "react";
import classNames from "classnames/bind";
import styles from "./FixedButton.module.scss";

const cx = classNames.bind(styles);

export default function FixedButton() {
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  const updateVisibility = useCallback(() => {
    const doc = document.documentElement;
    const scrollTop = window.pageYOffset || doc.scrollTop;
    const distanceFromBottom =
      doc.scrollHeight - (scrollTop + doc.clientHeight);
    // 바닥에서 100px 이상 떨어져 있으면 보이게
    setShowScrollBtn(distanceFromBottom >= 100);
  }, []);

  useEffect(() => {
    updateVisibility(); // 초기 상태 반영
    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);
    return () => {
      window.removeEventListener("scroll", updateVisibility);
      window.removeEventListener("resize", updateVisibility);
    };
  }, [updateVisibility]);

  const scrollToBottom = () => {
    const doc = document.documentElement;
    const bottom = doc.scrollHeight - doc.clientHeight;
    window.scrollTo({ top: bottom, behavior: "smooth" });
  };

  const handleClickCounselButton = () => {
    if (window.ChannelIO) {
      window.ChannelIO("showMessenger");
    } else {
      alert("상담 서버 연결 중입니다. 잠시 후 다시 시도해 주세요.");
    }
  };

  return (
    <>
      <button
        onClick={scrollToBottom}
        className={cx(showScrollBtn ? "scroll-button" : "hidden-scroll-button")}
      >
        <img
          className={cx("fixed-img")}
          src="/images/scroll.png"
          alt="scroll"
        />
      </button>
      <button
        onClick={handleClickCounselButton}
        className={cx("counsel-button")}
      >
        <img
          className={cx("fixed-img")}
          src="/images/counsel.png"
          alt="counsel"
        />
      </button>
    </>
  );
}
